import React, { useCallback } from 'react';
import {
  useAxisOptions,
  useCurrentPageId,
  useEditorSizePx,
  useIsEditing,
  useShowArrow,
  useApplyTextToAllPages,
  useMode,
  useEditedShape,
} from 'hooks';
import { PageConfigContextProvider } from 'context/pageConfig';
import useUpdateIsEditing from 'hooks/useUpdateIsEditing';
import { modalTypes, modes } from 'constants/index';
import store from 'store';
import { close } from 'actions/modal';
import { openModal } from 'utils/utils';
import SceneHelper from 'utils/SceneHelper';
import ArrowMemo from '../Arrow';
import Editor from '../Editor';
import c from './EditorOnePage.module.scss';

const EditorOnePage = () => {
  const currentPageId = useCurrentPageId();
  const [width, height] = useEditorSizePx(currentPageId);
  const isEditing = useIsEditing();
  const setIsEditing = useUpdateIsEditing();
  const showArrow = useShowArrow();
  const { xLabel, yLabel, axisColor } = useAxisOptions();
  const mode = useMode();
  const shape = useEditedShape();
  const applyTextToAllPages = useApplyTextToAllPages();

  const deselectShape = useCallback(() => {
    if (isEditing) {
      if (mode === modes.photoPrint && SceneHelper.isText(shape)) {
        openModal({
          type: modalTypes.confirm,
          modalProps: {
            header: 'Apply text to all images?',
            text: 'Do you want to apply the current text to all images in this design, or only to this image?',
            confirmText: 'Apply to all images',
            cancelText: 'Only this image',
            hideCancelButton: false,
            onConfirm: () => {
              applyTextToAllPages(shape.id, { includeText: true, includeStyle: true });
              store.dispatch(close());
              setIsEditing(false);
            },
            onClose: () => {
              setIsEditing(false);
              store.dispatch(close());
            },
          },
        });
      } else {
        setIsEditing(false);
      }
    }
  }, [applyTextToAllPages, isEditing, mode, setIsEditing, shape]);
  return (
    <div className={c.containerNewEditor} onClick={deselectShape}>
      <div className={c.newEditor}>
        <div style={{ display: 'flex' }}>
          {showArrow ? <ArrowMemo vertical width={height / 3} text={yLabel} color={axisColor} /> : null}
          <PageConfigContextProvider value={{ pageId: currentPageId, editing: true }}>
            <Editor />
          </PageConfigContextProvider>
        </div>
        {showArrow ? <ArrowMemo width={width / 3} text={xLabel} color={axisColor} /> : null}
      </div>
    </div>
  );
};

export default EditorOnePage;
